import React from "react";
import {IALData} from "../../components/modules/home/home";

export type AdvertiserLoginsState = {
    advertiserLogins:IALData[],
    refetchAdvertiserLogins:()=>void
    isLoadingAL:boolean

}
export const AdvertiserLoginsContext = React.createContext<AdvertiserLoginsState>({advertiserLogins:null,refetchAdvertiserLogins:()=>{},isLoadingAL:false})
